import { matchPath, useLocation } from 'react-router-dom';

export function useIsAuthOmitPath(authOmitPaths: string[] = []) {
  const loc = useLocation();
  return authOmitPaths.some(p => matchPath(p, loc.pathname));
}
